import styled from "styled-components";

export const StyledServiceBalancesWrapper = styled.div`
  position: relative;

  .service-balances-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px 1fr;
    grid-gap: 20px;

    &__update {
      display: inline-grid;
      justify-content:  end;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
      &__update {
        justify-content: start;
      }
    }
  }
  
  .service-balances-table {
    &__head,
    &__row {
      grid-template-columns: minmax(0, 400px) 1fr;
      border: none;
    }
    &__balance {
      &:not(:last-child) {
        padding-bottom: 3px;
      }
    }
  }
`;

export const StyledServiceBalancesUpdateLoading = styled.div`
  width: 100%;
  height: 100%;
  padding: 130px 25px 25px;
  text-align: center;
  background-color: ${({theme}) => theme.surface.loadingOverlay};
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
`;

export const StyledServiceBalancesUpdate = styled.div`
  display: inline-grid;
  grid-template-rows: 45px;
  button {
    height: 100%;
  }
`;

export const StyledServiceBalancesItemWrapper = styled.div`
  border-top: 1px solid ${({theme}) => theme.surface.border};
  &:last-child {
    border-bottom: 1px solid ${({theme}) => theme.surface.border};
  }
  
  .active {
    color: ${({theme}) => theme.brand.primary};
    background-color: ${({theme}) => theme.surface.hover};
    border-bottom: 1px solid ${({theme}) => theme.surface.border};
  }
`;

export const StyledServiceBalancesDetailsWrapper = styled.div`
  margin-left: 40px;
  padding: 20px;
  border-left: 1px solid ${({theme}) => theme.surface.border};
  & > div {
    &:not(:first-child) {
      padding-top: 20px;
    }
  }
  
  .title {
    color: ${({theme}) => theme.text.primary};
    padding-bottom: 3px;
  }

  .service-balance-details-head {
    padding-bottom: 15px;
    border-bottom: 1px solid ${({theme}) => theme.surface.border};
    &__name {
      padding: 5px;
      margin-bottom: 10px;
      color: ${({theme}) => theme.text.primary};
      font-weight: 700;
      background-color: ${({theme}) => theme.badge.neutralBackground};
      border-radius: 3px;
    }
    &__balance {
      padding: 3px 8px;
      color: ${({theme}) => theme.badge.successColor};
      font-weight: 600;
      background-color: ${({theme}) => theme.badge.successBackground};
      border-radius: 5px;
      display: inline-block;
      &-title {
        padding-bottom: 3px;
        font-weight: 500;
      }
    }
  }
  
  .service-balance-details-body {
    .clients-service-balances {
      margin-bottom: 0;
      &__head,
      &__row {
        grid-template-columns: minmax(0, 450px) 1fr;
      }
    }
  }
`;